import { withInstall } from '@bigin/utils'
import Avatar from './src/avatar.vue'

export const BAvatar = withInstall(Avatar)
export default BAvatar

export * from './src/avatar'
